<template>
  <div :class="classes" class="hidden lg:flex justify-center w-full">
    <div class="w-full flex bg-white dark:bg-lh_red px-8 py-4 justify-between">
      <router-link to="/" class="w-1/5 flex items-center h-fit space-x-5">
        <img alt="logo" :src="dashboardContents.salviLogo" class="w-[6vw]"/>
        <img alt="logo" :src="dashboardContents.logo" class="dark:hidden block w-[6vw]" />
        <img alt="logo" :src="dashboardContents.whiteLogo" class="hidden dark:block w-[6vw]" />
      </router-link>
      <!--<div class="flex space-x-4 xl:space-x-8 2xl:space-x-12 text-sm 2xl:text-base w-3/5 justify-center">
        <base-anchor-tag
          v-for="link in dashboardContents.links" :key="link.label"
          :label="link.label"
          :hasDropdown="link.hasDropdown"
          :dropdowns="link.links"
          isDesktop
        />
      </div>-->
      <div class="flex space-x-4 xl:space-x-8 2xl:space-x-12 items-center justify-end w-1/5">
        <navbar-buttons />
      </div>
    </div>
  </div>

  <div class="block lg:hidden">
    <div class="flex w-full p-4 last:justify-end justify-between">
      <button @click="openCloseNavbar()" class="z-50 lg:hidden fill-black dark:fill-white">
        <Bars3Icon class="w-5 h-5" />
      </button>
      <navbar-buttons class="w-2/3" />
    </div>

    <div class="w-full flex absolute justify-between">
      <transition name="slide-fade">
        <div class="flex absolute w-screen p-14 h-full md:w-1/2 lg:w-1/4 shadow-inner
          space-y-5 z-40 bg-white dark:bg-lh_gray" v-if="showNavbar">
          <div :class="mobileClasses">
            <router-link to="/" class="w-1/2 mb-4" @click="openCloseNavbar()">
              <img alt="logo" :src="dashboardContents.logo" class="w-full"/>
            </router-link>
            <div class="flex flex-col space-y-2 text-base">
              <base-anchor-tag
                v-for="link in dashboardContents.links" :key="link.label"
                :label="link.label"
                :hasDropdown="link.hasDropdown"
                :dropdowns="link.links"
                @select="openCloseNavbar()"
              />
            </div>
          </div>
        </div>
      </transition>
      <button
        class="w-screen z-30 h-screen backdrop-blur-md lg:hidden cursor-default flex place-self-end"
        :class="showNavbar ? 'opacity-100 transition-opacity duration-500 ease-in-out' : 'opacity-0 hidden'"
        @click="openCloseNavbar()"
      >
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import appVariables from '@/config/appVariables.json';
import NavbarButtons from '@/components/base/NavbarButtons.vue';
import BaseAnchorTag from '@/components/base/BaseAnchorTag.vue';
import { Bars3Icon } from '@heroicons/vue/24/outline';

export default {
  components: {
    NavbarButtons,
    BaseAnchorTag,
    Bars3Icon,
  },
  data() {
    return {
      caseClass: {
        uppercase: 'uppercase',
        lowercase: 'lowercase',
        capitalize: 'capitalize',
      },
      weightClass: {
        light: 'font-light',
        normal: 'font-normal',
        bold: 'font-bold',
      },
      directionClass: {
        horizontal: 'flex flex-row space-x-4',
        vertical: 'flex flex-col space-y-2',
      },
      showNavbar: false,
      dashboardContents: appVariables,
    };
  },
  props: {
    fontCase: {
      type: String,
      default: 'uppercase',
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    mobileDirection: {
      type: String,
      default: 'vertical',
    },
    fontWeight: {
      type: String,
      default: 'light',
    },
    elementsColor: {
      type: String,
      default: 'text-black dark:text-white',
    },
    slideCart: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('auth', ['authenticated', 'isSuperAdmin']),
    classes() {
      // eslint-disable-next-line max-len
      return `${this.caseClass[this.fontCase]} ${this.directionClass[this.direction]} ${this.weightClass[this.fontWeight]} ${this.elementsColor}`;
    },
    mobileClasses() {
      // eslint-disable-next-line max-len
      return `${this.caseClass[this.fontCase]} ${this.directionClass[this.mobileDirection]} ${this.weightClass[this.fontWeight]} ${this.elementsColor}`;
    },
  },
  methods: {
    openCloseNavbar() {
      this.showNavbar = !this.showNavbar;
      this.stopScroll();
    },
    stopScroll() {
      if (this.showNavbar === true) {
        const element = document.body;
        element.classList.add('overflow-hidden');
        return;
      }
      const element = document.body;
      element.classList.remove('overflow-hidden');
    },
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.5s ease-in-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
